console.log("Data JS loaded for Wocawson project page.");

class ProjectData {
  constructor() {
    // Step 1: Detect language and current path
    this.lang = document.documentElement.lang || "fr";
    console.log(this.lang);

    this.currentPath = window.location.pathname;
    // this.currentPath = "/projets/saraguay-reed/";

    this.init = this.init.bind(this);
    this.init();
  }

  async init() {
    // Step 2: Fetch projets.json and find matching project
    this.data = await fetch("/themes/projets/data/projets.json")
      .then(response => response.json())
      .then(data => {
        // Find project where url-fiche-{lang} matches currentPath
        const urlKey = `url-fiche-${this.lang}`;
        const project = data.find(item =>
          this.currentPath.includes(item[urlKey])
        );
        if (project) {
          const mappedProject = {
            latitude: project.latitude,
            longitude: project.longitude,
            "nom-projet": project[`nom-projet-${this.lang}`],
            "region-administrative-quebec":
              project["region-administrative-quebec"],
            "statut-projet": project[`statut-projet-${this.lang}`],
            "type-projet": project[`type-projet-${this.lang}`]
          };
          console.log("Projet (données filtrées):", mappedProject);

          return mappedProject;
        }
      })
      .catch(err => {
        console.error("Erreur lors du chargement des données projets:", err);
      });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ProjectData();
});
